/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* plugins/compare-mode/assets/js/compare-mode.js — period-over-period builder + preview + export. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["compare-mode"] = "1.0.5"; } catch (e) {}
  var META = {};
  var SEL = { dataset:"pages", preset:"last_30_days", from:null, to:null, mode:"previous_period", b_from:null, b_to:null,
              format:"csv", device:"", country:"", rows:20, page_size:"A4", orientation:"portrait" };

  function q(k){ return document.querySelector('[data-cm="'+k+'"]'); }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }
  function site(){ return (window.GS&&GS.site)||""; }
  function fill(el,items,vf,lf,cur){ if(!el)return; el.innerHTML=items.map(function(it){var v=vf(it);return '<option value="'+esc(v)+'"'+(v===cur?" selected":"")+'>'+esc(lf(it))+'</option>';}).join(""); }
  function fmtNum(n){ return Number(n).toLocaleString(); }
  /* When the previous period had none of this row, there is no percentage to show: a change from zero is
     undefined, not 100%. But a bare "new" reads as a mystery next to a column of percentages, so say what
     it means and name the window it was compared against. RANGE_B is filled from the response. */
  var RANGE_B = null;
  function pctText(r){
    if (r.pct === null) return '<span class="cm-new" data-tip="' + esc(newTip()) + '">new</span>';
    return (r.delta > 0 ? "+" : "") + r.pct + "%";
  }
  function newTip(){
    return RANGE_B
      ? "Not present between " + RANGE_B.from + " and " + RANGE_B.to + ", so there is no percentage to "
        + "compare against \u2014 a change from zero is undefined, not 100%."
      : TR('compar.f3.not_present_in_the_comparison_peri');
  }
  function trendClass(t){ return t==="up"?"cm-up":(t==="down"?"cm-down":"cm-flat"); }
  function arrow(t){ return t==="up"?"\u2191":(t==="down"?"\u2193":"\u2192"); }

  function body(){
    return { dataset:SEL.dataset, format:SEL.format, date_preset:SEL.preset||null, date_start:SEL.from, date_end:SEL.to,
             compare_mode:SEL.mode, b_start:SEL.b_from, b_end:SEL.b_to, rows:+((q("rows")||{}).value||20),
             filters:{device:SEL.device||null,country:SEL.country||null}, title:(q("title")||{}).value||"",
             filename:(q("filename")||{}).value||"", page_size:SEL.page_size, orientation:SEL.orientation };
  }

  function preview(){
    if(!site())return;
    GS.api("/plugin/compare-mode/preview?site="+encodeURIComponent(site()),{method:"POST",body:JSON.stringify(body())}).then(function(r){
      var d=r&&r.data; if(!d||!d.ok)return;
      RANGE_B = d.range_b || null;    // so "new" can name the window it was measured against
      var lbl=q("range-label"); if(lbl) lbl.textContent = d.range_a.from+" → "+d.range_a.to+"  vs  "+d.range_b.from+" → "+d.range_b.to;
      var kh=q("preview-kpis");
      if(kh) kh.innerHTML=[[TR('compar.g.pageviews'),"pageviews"],[TR('compar.g.visitors'),"visitors"],[TR('compar.g.sessions'),"sessions"]].map(function(m){
        var c=d.kpis[m[1]];
        return '<div class="cm-kpi"><div class="cm-kpi-v">'+fmtNum(c.current)+'</div><div class="cm-kpi-l">'+m[0]+'</div>'+
               '<div class="cm-kpi-d '+trendClass(c.trend)+'">'+arrow(c.trend)+' '+pctText(c)+' <span class="cm-muted">('+(c.delta>0?"+":"")+fmtNum(c.delta)+')</span></div></div>';
      }).join("");
      var th=q("preview-table");
      if(th){
        if(!d.rows.length){ th.innerHTML='<div class="cm-muted">'+TR('compar.no_data_in_these_periods')+'</div>'; return; }
        function cmRow(r){
          return '<tr><td>'+esc(r.key)+'</td><td class="cm-num">'+fmtNum(r.current)+'</td><td class="cm-num">'+fmtNum(r.previous)+
                 '</td><td class="cm-num '+trendClass(r.trend)+'">'+arrow(r.trend)+' '+pctText(r)+'</td></tr>';
        }
        var h='<table class="cm-table"><thead><tr><th>'+esc(d.key_label)+'</th><th class="cm-num">'+TR('compar.g.current')+'</th><th class="cm-num">'+TR('compar.g.previous')+'</th><th class="cm-num">'+TR('compar.g.change')+'</th></tr></thead><tbody></tbody></table>';
        th.innerHTML=h;
        var cmt=th.querySelector('tbody');
        if (window.GSMore) GSMore.mount({ container:cmt, table:true, colspan:4, items:d.rows, pageSize:20, emptyText:TR('compar.no_data_in_these_periods'), render:cmRow });
        else cmt.innerHTML=d.rows.map(cmRow).join('');
      }
    });
  }

  function download(){
    if(!site())return;
    var btn=q("download"); if(btn){btn.disabled=true;btn.dataset.t=btn.textContent;btn.textContent=TT('comp.a.preparing');}
    GS.api("/plugin/compare-mode/export?site="+encodeURIComponent(site()),{method:"POST",body:JSON.stringify(body())}).then(function(r){
      if(btn){btn.disabled=false;btn.textContent=btn.dataset.t||"Download";}
      var d=r&&r.data; if(!d||!d.ok){var n=q("status");if(n)n.textContent=TT('comp.a.export_failed');return;}
      var bin=atob(d.b64),len=bin.length,bytes=new Uint8Array(len);
      for(var i=0;i<len;i++)bytes[i]=bin.charCodeAt(i);
      var blob=new Blob([bytes],{type:d.mime}),url=URL.createObjectURL(blob),a=document.createElement("a");
      a.href=url;a.download=d.filename;document.body.appendChild(a);a.click();
      setTimeout(function(){URL.revokeObjectURL(url);a.remove();},1000);
      var n=q("status");if(n)n.textContent="Downloaded "+d.filename+".";
    });
  }

  function saveSettings(){
    var b={default_preset:(q("set-preset")||{}).value||"last_30_days",default_mode:(q("set-mode")||{}).value||"previous_period",default_format:(q("set-format")||{}).value||"csv"};
    GS.api("/plugin/compare-mode/save-settings?site="+encodeURIComponent(site()),{method:"POST",body:JSON.stringify(b)}).then(function(r){
      var n=q("save-note");if(n){n.hidden=false;n.textContent=(r&&r.data&&r.data.ok)?"Saved.":TR('compar.g.save_failed');setTimeout(function(){n.hidden=true;},1500);}
    });
  }

  function loadSettings(){
    GS.api("/plugin/compare-mode/settings?site="+encodeURIComponent(site())).then(function(r){
      var c=r&&r.data&&r.data.config; if(!c){preview();return;}
      if(c.default_preset){SEL.preset=c.default_preset;var pe=q("preset");if(pe)pe.value=c.default_preset;var sp=q("set-preset");if(sp)sp.value=c.default_preset;var cw=q("custom-range-a");if(cw)cw.hidden=!!c.default_preset;}
      if(c.default_mode){SEL.mode=c.default_mode;var me=q("compare-mode");if(me)me.value=c.default_mode;var sm=q("set-mode");if(sm)sm.value=c.default_mode;var bw=q("custom-range-b");if(bw)bw.hidden=(c.default_mode!=="custom");}
      if(c.default_format){SEL.format=c.default_format;var fe=q("format");if(fe)fe.value=c.default_format;var sf=q("set-format");if(sf)sf.value=c.default_format;}
      preview();
    });
  }

  function load(){
    GS.api("/plugin/compare-mode/dimensions?site="+encodeURIComponent(site())).then(function(r){
      var d=r&&r.data; if(!d||!d.ok)return; META=d;
      fill(q("dataset"),d.datasets,function(x){return x.key;},function(x){return x.label;},SEL.dataset);
      fill(q("preset"),[{p:""}].concat(d.presets.map(function(p){return{p:p};})),function(x){return x.p;},function(x){return x.p?x.p.replace(/_/g," "):TR('compar.g.custom_range');},SEL.preset);
      fill(q("compare-mode"),d.modes.map(function(m){return{m:m};}),function(x){return x.m;},function(x){return x.m.replace(/_/g," ");},SEL.mode);
      fill(q("format"),d.formats.map(function(f){return{f:f};}),function(x){return x.f;},function(x){return x.f.toUpperCase();},SEL.format);
      fill(q("page-size"),d.page_sizes.map(function(s){return{s:s};}),function(x){return x.s;},function(x){return x.s.toUpperCase();},SEL.page_size);
      fill(q("orientation"),d.orientations.map(function(o){return{o:o};}),function(x){return x.o;},function(x){return x.o.charAt(0).toUpperCase()+x.o.slice(1);},SEL.orientation);
      loadSettings();
      applyDeepLink();
    });
  }

  // Segments Intelligence (and any other surface) can deep-link here with ?device= / ?country= to pre-set
  // the filter. Sets the SEL filter (so the comparison is actually scoped) and, when the matching select
  // exists, reflects the value in the dropdown, then previews.
  function applyDeepLink(){
    try{
      var p=new URLSearchParams(location.search), did=false, dev=p.get("device"), ctry=p.get("country");
      if(dev){ SEL.device=dev; var ds=q("device"); if(ds) ds.value=dev; did=true; }
      if(ctry){ SEL.country=ctry; var cs=q("country"); if(cs) cs.value=ctry; did=true; }
      if(did) preview();
    }catch(e){}
  }

  document.addEventListener("change",function(e){
    var t=e.target,k=t&&t.getAttribute&&t.getAttribute("data-cm");
    if(k==="dataset"){SEL.dataset=t.value;preview();}
    else if(k==="preset"){SEL.preset=t.value;var cw=q("custom-range-a");if(cw)cw.hidden=!!t.value;preview();}
    else if(k==="from"){SEL.from=t.value;if(!SEL.preset)preview();}
    else if(k==="to"){SEL.to=t.value;if(!SEL.preset)preview();}
    else if(k==="compare-mode"){SEL.mode=t.value;var bw=q("custom-range-b");if(bw)bw.hidden=(t.value!=="custom");preview();}
    else if(k==="b-from"){SEL.b_from=t.value;if(SEL.mode==="custom")preview();}
    else if(k==="b-to"){SEL.b_to=t.value;if(SEL.mode==="custom")preview();}
    else if(k==="format"){SEL.format=t.value;}
    else if(k==="page-size"){SEL.page_size=t.value;}
    else if(k==="orientation"){SEL.orientation=t.value;}
    else if(k==="device"){SEL.device=t.value;preview();}
    else if(k==="country"){SEL.country=t.value;preview();}
    else if(k==="rows"){SEL.rows=+t.value;preview();}
  });
  document.addEventListener("click",function(e){
    var b=e.target&&e.target.closest&&e.target.closest("[data-cm-btn]"); if(!b)return;
    var k=b.getAttribute("data-cm-btn");
    if(k==="download")download(); else if(k==="preview")preview(); else if(k==="save-settings")saveSettings();
  });
  document.addEventListener("gs:ready",function(){load();});
  document.addEventListener("gs:site-change",function(){load();});
  if(window.GS&&GS.site)load();
})();
